import Vue from 'vue'
import Vuex from 'vuex'
import { onBoarding } from './onBoardingStore'
import { portfolio } from './portfolio'
import { dashboard } from './dashboard'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const getInitialState = () => {
    return {
        isLoading: false,
        isSessionOver: false,
        userName: null,
        hideReferralCode: false,
        loaderMessage: 'We are processing your request'
    }
}
export default new Vuex.Store({
    state: getInitialState(),
    plugins: [createPersistedState()],
    mutations: {
        toggleIsLoading (state) {
            state.isLoading = !state.isLoading
        },
        isLoading (state, data) {
            state.isLoading = true
            if (data?.message) {
                state.loaderMessage = data.message
            }
        },
        isNotLoading (state) {
            state.isLoading = false
            state.loaderMessage = 'We are processing your request'
        },
        setSessionOver (state) {
            if (state.isSessionOver) {
                state.isSessionOver = false
            }
            state.isSessionOver = true
        },
        setSessionStart (state) {
            state.isSessionOver = false
        },
        setUserName (state, value) {
            state.userName = value
        },
        hideReferralCode (state, value) {
            state.hideReferralCode = value
        },
        reset (state) {
            document.cookie = 'token=;-1; path=/'
            const initialState = getInitialState()
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key]
            })
        }
    },
    getters: {
        getUserName: (state) => {
            return state.userName
        },
        getLoaderMessage: (state) => {
            return state.loaderMessage
        }
    },
    actions: {
        setUserName ({ commit }, value) {
            commit('setUserName', value)
        },
        logout ({ commit }) {
            commit('reset')
            commit('onBoarding/reset')
            commit('dashboard/reset')
            commit('portfolio/reset')
        }
    },
    modules: {
        onBoarding,
        portfolio,
        dashboard
    }
})
